import { SEARCH_PROVIDER_QUERY_PARAM } from './search-provider-preference';

/**
 * URL query keys that control app behaviour but are not job index facets.
 * Must not be mapped into refinementList / Typesense filter_by.
 */
export const SRP_NON_FILTER_QUERY_PARAMS = new Set<string>([
  SEARCH_PROVIDER_QUERY_PARAM,
]);

export function isSrpNonFilterQueryParam(paramKey: string): boolean {
  const normalized = paramKey.replace(/^\uFEFF/, '').trim().toLowerCase();
  return SRP_NON_FILTER_QUERY_PARAMS.has(normalized);
}
